import PageTitle from '@components/common/PageTitle';
import config from '@config';
import { useAppStateSelector } from '@redux/hooks';
import AppSetting from '@xFrame4/business/AppSetting';
import { useTranslate } from '@xFrame4/components/Hooks';
import ALink from '@xFrame4/components/next/ALink';
import SmoothImage from '@xFrame4/components/SmoothImage';
import { FunctionComponent } from 'react';
import ContactForm from './ContactForm';

interface ContactProps
{
    appSettings: AppSetting[];
}

const Contact: FunctionComponent<ContactProps> = (props) =>
{
    const t = useTranslate();
    const language = useAppStateSelector(state => state.layout.language);
    const facebookPage = AppSetting.getValueFromArray(props.appSettings, 'facebook_page');
    const instagramPage = AppSetting.getValueFromArray(props.appSettings, 'instagram_page');
    const saatchiartUrl = AppSetting.getValueFromArray(props.appSettings, 'saatchiart_url');

    /** Social media links */
    let socialLinks = [
        /*
        {
            name: 'Facebook',
            link: facebookPage.url
        },
        */
        {
            name: 'Instagram',
            link: instagramPage.url
        },
        {
            name: 'saatchiart',
            link: saatchiartUrl.value
        }
    ];

    let cmpSociaLinks = socialLinks.map((socialLink, i) =>
        <div key={i} className="contact-social-link me-2">
            <ALink href={socialLink.link} target="_blank" className="content-link">{socialLink.name}</ALink>
            {(i != socialLinks.length - 1) && <span className="ms-2">{'//'}</span>}
        </div>
    )

    /** Render */
    return (
        <div className="contact">
            <PageTitle title={t('CONTACT')} />

            <div className="row">
                <div className='col-lg-7'>
                    <div className="text-gray-700 mb-4">
                        <div>{t('CONTACT_SECTION_2_TITLE')}</div>
                        <div className="contact-social-links d-flex mb-3">
                            {cmpSociaLinks}
                        </div>
                        <div className="contact-desc mb-3" dangerouslySetInnerHTML={{__html: t('CONTACT_SECTION_2_DESC')}}></div>
                        <div className="privacy-policy-cta">
                            <ALink className="content-link" href={config.appUrl + language.code + '/privacy'}>{t('CONTACT_SECTION_2_PRIVACY_POLICY_CTA')}</ALink>
                        </div>
                    </div>

                    {false &&
                    <div className="mb-5">
                        <SmoothImage
                            src={config.defaultPublicDirBaseUrl + 'img/contact/contact-image.jpg'}
                            width={1080}
                            height={747}
                            className="img-fluid border border-primary"
                            alt={t('LOGO_TEXT')}
                        />
                    </div>
                    }

                    <ContactForm />
                </div>
            </div>
        </div>
    );
}

export default Contact;